import styled from "styled-components/native";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { convertShapeType } from "./utils";
import { useTheme } from "styled-components/native";
import { Image } from "react-native";
import { FALLBACK_IMAGE_ASSET } from "@utils/product/searchResultConstants";
import { DefaultTheme } from "styled-components/native";

export interface EmptyImagePreviewProps {
  shape?: string;
  size?: number;
  extraSmallImage?: boolean;
  isExternalView?: string;
  borderRadius?: number;
  containerSize?: number;
  isPair?: boolean;
}

const EmptyImagePreview = ({
  shape,
  size,
  extraSmallImage = false,
  isExternalView,
  borderRadius,
  containerSize,
  isPair = false,
}: EmptyImagePreviewProps) => {
  const theme = useTheme();
  const shapeIcon = convertShapeType(shape);

  const NoShapeAvailableComponent = () => {
    return (
      <Image
        style={{
          height: size,
          width: size,
        }}
        source={{
          uri: FALLBACK_IMAGE_ASSET,
        }}
      />
    );
  };

  return (
    <CenterContainer
      borderRadius={borderRadius}
      extraSmallImage={extraSmallImage}
      isExternalView={!!isExternalView}
      containerSize={containerSize}
      flexDirection={isPair ? "row" : "column"}
    >
      {shapeIcon?.icon_name ? (
        isPair ? (
          <>
            <VDBIcon
              color={theme["core-06"]}
              size={size ? size / 2 : 16}
              variant={IconsVariant.VDBCustom}
              name={shapeIcon?.icon_name}
            />
            <VDBIcon
              color={theme["core-06"]}
              size={size ? size / 2 : 16}
              variant={IconsVariant.VDBCustom}
              name={shapeIcon?.icon_name}
            />
          </>
        ) : (
          <VDBIcon
            color={theme["core-06"]}
            size={size}
            variant={IconsVariant.VDBCustom}
            name={shapeIcon?.icon_name}
          />
        )
      ) : (
        <NoShapeAvailableComponent />
      )}
    </CenterContainer>
  );
};

const CenterContainer = styled.View<{
  extraSmallImage: boolean;
  isExternalView: boolean;
  containerSize: number;
  borderRadius: number;
  flexDirection?: "row" | "column";
}>`
  justify-content: center;
  align-items: center;
  align-content: center;
  border-radius: ${({ borderRadius }: { borderRadius: number }) =>
    `${borderRadius ?? 12}px`};
  background-color: ${({ theme }: { theme: DefaultTheme }) => theme["core-01"]};
  width: ${({
    extraSmallImage,
    isExternalView,
    theme,
    containerSize,
  }: {
    extraSmallImage: boolean;
    isExternalView: boolean;
    theme: DefaultTheme;
    containerSize: number;
  }) =>
    extraSmallImage
      ? isExternalView && theme.isMobile
        ? containerSize
          ? containerSize
          : "150px"
        : theme.isMobile
        ? "150px"
        : "415px"
      : "100%"};
  height: ${({
    extraSmallImage,
    isExternalView,
    theme,
    containerSize,
  }: {
    extraSmallImage: boolean;
    isExternalView: boolean;
    theme: DefaultTheme;
    containerSize: number;
  }) =>
    extraSmallImage
      ? isExternalView && theme.isMobile
        ? containerSize
          ? containerSize
          : "150px"
        : theme.isMobile
        ? "150px"
        : "415px"
      : "100%"};
  display: flex;
  flex-direction: ${({ flexDirection }: { flexDirection?: "row" | "column" }) =>
    flexDirection || "column"};
`;

export default EmptyImagePreview;
